import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { MY_ACCOUNTS_PATH, SYNC_UNITS_PATH } from '../constants/syncRoutes';
import useNavigation from '../hooks/use-navigation';
import { UNIFIED_UPLOAD_PATH } from '../pages/UnifiedUploadPage';

// screens.md §Спільне: the caption and the two dots of every screen SCR-01..SCR-05 (null → not a screen of the flow).
function stepOf(currentPath) {
  if (currentPath === UNIFIED_UPLOAD_PATH || currentPath?.startsWith(`${UNIFIED_UPLOAD_PATH}/`)) {
    return { label: 'upload', dots: ['active', 'idle'] };
  }
  if (currentPath === SYNC_UNITS_PATH) return { label: 'syncing', dots: ['done', 'active'] };
  if (currentPath?.startsWith(`${SYNC_UNITS_PATH}/`)) return { label: 'decision', dots: ['done', 'active'] };
  if (currentPath === MY_ACCOUNTS_PATH) return { label: 'myAccounts', dots: ['idle', 'idle'] };
  if (currentPath?.startsWith('/accounts/')) return { label: 'account', dots: ['idle', 'idle'] };
  return null;
}

const DOT_CLASS = { active: 'bg-accent-solid', done: 'bg-success', idle: 'bg-border' };

function StepIndicator() {
  const { t } = useTranslation();
  const { currentPath } = useNavigation();
  const step = stepOf(currentPath);
  if (!step) return null;

  return (
    <div data-testid="step-indicator" className="flex items-center gap-3 px-5 md:px-10 py-5 border-b border-border">
      <div className="flex items-center gap-1.5">
        {step.dots.map((state, index) => (
          <span key={index} data-testid="step-dot" className={clsx('w-2 h-2 rounded-full', DOT_CLASS[state])} />
        ))}
      </div>
      <span className="text-sm text-text-muted">{t(`syncCommon.steps.${step.label}`)}</span>
    </div>
  );
}

export default StepIndicator;
